import { render, staticRenderFns } from "./IdSearch.vue?vue&type=template&id=2314676f&scoped=true&"
import script from "./IdSearch.vue?vue&type=script&lang=js&"
export * from "./IdSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2314676f",
  null
  
)

export default component.exports